<template>
    <csp-table
        icon="inticon-autoclaim_company"
        :items-ajax-url="itemsAjaxUrl"
        table-headline="Zugeordnete Autohäuser"/>
</template>

<script>
    export default {
        name: 'CarDealerAssignments',
        props: {
            itemsAjaxUrl: {
                type: String,
                required: true,
            },
        },
        computed: {
        },
    }
</script>
